import BuildingType from '@/roc/building/BuildingType';
import Effects from '@/roc/effects/Effects';
import CultureBonus from '@/roc/effects/CultureBonus/CultureBonus';
import CultureAmount from '@/roc/effects/CultureBonus/CultureAmount';
import CultureRange from '@/roc/effects/CultureBonus/CultureRange';

const QuintennialMonument = {
  id: '140',
  name: 'Quintennial Monument',
  width: 2,
  height: 2,
  type: BuildingType.COLLECTABLE,
  era: 'stoneAge',
  icon: 'Quintennial_Monument',
  minLevel: 1,
  maxLevel: 1,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Quintennial_Monument',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new CultureBonus(
      CultureAmount.asFlat(500),
      CultureRange.asFlat(3),
    ),
  ]),
};

export default QuintennialMonument;
